const getters = {
  sidebar: (state) => state.app.sidebar,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  mailbox: (state) => state.user.mailbox,
  name: (state) => state.user.name,
  userInfo: (state) => state.user.userInfo,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  clientList: (state) => state.user.clientList,
  groupClient: (state) => state.user.groupClient,
  permission_routes: (state) => state.permission.routes,
  topbarRouters: (state) => state.permission.topbarRouters,
  defaultRoutes: (state) => state.permission.defaultRoutes,
  sidebarRouters: (state) => state.permission.sidebarRouters,
  activeName: (state) => state.knowledge.activeName,
  modifyPasswd: (state) => state.user.modifyPasswd,
  firstLogin: (state) => state.user.firstLogin,
}
export default getters
